<!--
// app/components/Shared/TwitterIcon.vue
-->
<script setup lang="ts">
type Props = {
  width?: number | string;
  height?: number | string;
  profileLink?: string;
};

withDefaults(defineProps<Props>(), {
  width: 20,
});
</script>

<template>
  <a :href="profileLink" target="_blank">
    <svg fill="none" :height="height" :width="width" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m11.539 8.56164 7.1255-8.100458h-1.6885l-6.187 7.033508-4.94157-7.033508h-5.699481l7.472571 10.635918-7.472571 8.4946h1.688591l6.53363-7.4277 5.21863 7.4277h5.6995l-7.7497-11.03006zm-2.31272 2.62916-.75712-1.0591-6.0242-8.42734h2.59358l4.86159 6.80114.75717 1.05909 6.3195 8.84041h-2.5936l-5.15692-7.2138z"
        fill="currentColor"
      />
    </svg>
  </a>
</template>

<style scoped></style>
